// Public copy from TRLR_Landing_Page_PRD_2026-10-02.docx.
// Shared by the landing page and the standalone About route.
export const ABOUT_PARAGRAPHS = [
  'Life’s biggest decisions depend on people. We’re building the technology to understand how they behave, predict how they respond and simulate what could happen next.',
  'Through conversation, TRLR develops an Echo: an evolving model of a person’s patterns of behaviour. What they notice. What matters to them. How they respond when circumstances change.',
  'Our first milestone is demonstrating person-specific prediction across different situations. The larger vision is to bring Echoes together, giving people a way to explore decisions and their possible consequences before living with them.',
];

export const TEAM = [
  { name: 'Kanishk', role: 'Co-Founder & CEO', line: 'Building TRLR from first principles.' },
  { name: 'Anant', role: 'Co-Founder & CTO', line: 'Turning the vision into a working system.' },
];

export const DIRECTIONS = [
  {
    name: 'Echo',
    desc: 'An understanding of a person that develops through conversation. Patterns emerge, assumptions are tested and the model evolves.',
  },
  {
    name: 'Prediction',
    desc: 'Understanding that can be tested. Predict a person’s response before they give it, then compare the prediction with what actually happens.',
  },
  {
    name: 'Simulation',
    desc: 'Our next horizon: bring multiple Echoes into the same scenario. Explore how different people, choices and circumstances could change what happens next.',
  },
];

export const CONTACT = {
  heading: 'Say hello.',
  description: 'For partnerships, research, investment or joining the team.',
  email: 'info@thetrlr.com',
  closing: 'A chance to step into the same river twice.',
};
